const Eula = {
  HeaderText: "Eula.HeaderText",
  TermsAndConditions: "Eula.TermsAndConditions",
  TermsOfUse: "Eula.TermsOfUse",
  AcceptUserAgreement: "Eula.AcceptUserAgreement",
  Suspend: "Eula.Suspend",
  }
export default Eula;